import {graphql} from '@/gql'

export const NeedOnboarding = graphql(`
    query NeedOnboarding {
        me {
            avatar
        }
    }
`)

export const Me = graphql(`
    query Me($pagination: PaginationInput) {
        me {
            uuid
            username
            firstName
            lastName
            premium
            language
            avatar
            league
            wallet {
                uuid
                balance
                transactions(pagination: $pagination) {
                    uuid
                    txType
                    wallet
                    birdUuid
                    bird
                    amount
                    comment
                    timestamp
                }
            }
            goals {
                name
                description
            }
        }
    }
`)

export const Bird = graphql(`
    query Bird($uuid: String!) {
        bird(uuid: $uuid) {
            uuid
            username
            firstName
            lastName
            premium
            avatar
            league
        }
    }
`)

export const Birds = graphql(`
    query Birds($uuid: String, $league: League, $pagination: PaginationInput) {
        birds(uuid: $uuid, league: $league, pagination: $pagination) {
            uuid
            username
            firstName
            lastName
            premium
            avatar
            league
            wallet {
                balance
            }
        }
    }
`)

export const Wallet = graphql(`
    query Wallet($uuid: String!) {
        wallet(uuid: $uuid) {
            uuid
            bird {
                uuid
                username
                firstName
                lastName
                premium
                avatar
                league
            }
            balance
        }
    }
`)

export const Wallets = graphql(`
    query Wallets($uuid: String, $pagination: PaginationInput) {
        wallets(uuid: $uuid, pagination: $pagination) {
            uuid
            bird {
                uuid
                username
                firstName
                lastName
                premium
                avatar
                league
            }
            balance
        }
    }
`)

export const Transaction = graphql(`
    query Transaction($uuid: String!) {
        transaction(uuid: $uuid) {
            uuid
            sender {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            recipient {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            amount
            comment
            timestamp
        }
    }
`)

export const Transactions = graphql(`
    query Transactions($uuid: String, $pagination: PaginationInput) {
        transactions(uuid: $uuid, pagination: $pagination) {
            uuid
            sender {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            recipient {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            amount
            comment
            timestamp
        }
    }
`)

export const Goals = graphql(`
    query Goals {
        goals {
            name
            description
            discoveredAt
        }
    }
`)
